import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ApiCallLog } from './api-call-log.model';
import { PagedEntities } from '@app/shared/abstract/paged-entities';

export interface ApiCallLogQuery {
  pageNum?: number;
  pageSize?: number;
  status_code?: number | number[];
  method?: string | string[];
  client_id?: string;
  route_name?: string | string[];
  q?: string;
}

@Injectable({ providedIn: 'root' })
export class ApiCallLogsService {
  private readonly baseUrl = `${environment.apiUrl}/api/api-call-logs`;

  constructor(private http: HttpClient) {}

  getLogs(params: ApiCallLogQuery = {}): Observable<PagedEntities<ApiCallLog>> {
    return this.http.get<PagedEntities<ApiCallLog>>(this.baseUrl, {
      params: {
        pageNum: params.pageNum ?? 1,
        pageSize: params.pageSize ?? 25,
        ...(params.status_code ? { status_code: params.status_code } : {}),
        ...(params.method ? { method: params.method } : {}),
        ...(params.client_id ? { client_id: params.client_id } : {}),
        ...(params.route_name ? { route_name: params.route_name } : {}),
        ...(params.q ? { q: params.q } : {}),
      },
    });
  }

  getLog(id: number): Observable<{ data: ApiCallLog }> {
    return this.http.get<{ data: ApiCallLog }>(`${this.baseUrl}/${id}`);
  }
}
